import { useState, useEffect } from "react";
import { Category, Product } from "../types/restaurant";
import api from "../../../../../../features/auth/axiosConfig";

export const useRestaurantData = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      const res = await api.get(`/app/v1/pos/category?include_deleted=False&pageNumber=&pageSize=`);
      setCategories(res.data.category_details);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await api.get("/app/v1/pos/product?is_deleted=False");
      setProducts(res.data.result);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchCategories(), fetchProducts()]).finally(() => setLoading(false));
  }, []);

  return { categories, products, loading, refetchCategories: fetchCategories, refetchProducts: fetchProducts };
};